import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/default.svg'


const _withScopeId = n => (_pushScopeId("data-v-73d8903a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap wrap" }
const _hoisted_2 = { class: "hearder mod_c_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动预约", -1))
const _hoisted_4 = {
  key: 1,
  class: "content"
}
const _hoisted_5 = { class: "conleft" }
const _hoisted_6 = { class: "cv_img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"300px"}
}, null, -1))
const _hoisted_9 = { class: "conright" }
const _hoisted_10 = { class: "itemText" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预约方式：", -1))
const _hoisted_12 = { class: "itemText" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公众号名：", -1))
const _hoisted_14 = { class: "itemDate" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开播时间：", -1))
const _hoisted_16 = { class: "itemDate" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "定时发送：", -1))
const _hoisted_18 = { class: "itemText" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自动弹出：", -1))
const _hoisted_20 = { class: "itemText" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "itemBut" }
const _hoisted_24 = { class: "itemTable" }
const _hoisted_25 = { class: "page_item" }
const _hoisted_26 = { class: "save" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "form_item mar_bot" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_item_span" }, "用户名：", -1))
const _hoisted_30 = { class: "form_item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_item_span" }, "手机号：", -1))
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "form_item mar_bot" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_item_span" }, "用户名：", -1))
const _hoisted_35 = { class: "form_item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_item_span" }, "手机号：", -1))
const _hoisted_37 = {
  key: 0,
  class: "import_cen"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传文件只能为excel文件，且为xlsx,xls格式", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = { class: "sendTalbe" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }

import Crumb from '@/components/Crumb.vue';
import CDelModal from '@/components/CDelModal.vue';
import { RootModal } from '@/components/CDelModal.vue';
import { computed, getCurrentInstance, reactive, inject, ref, unref, nextTick, watch } from 'vue';
import {
  Radio,
  Input,
  Menu,
  Dropdown,
  Table,
  Modal,
  message,
  Pagination,
  Upload,
  DatePicker,
  notification,
} from 'ant-design-vue';
import { Key } from 'ant-design-vue/lib/_util/type';
import router from '@/router';
import { getToken } from '@/plugins/cookie';
import { SearchOutlined } from '@ant-design/icons-vue';
import { Moment } from 'moment';
import moment from 'moment';
import { LiveInfo } from '@/store/modules/live/types';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import http from '@/api/eventreservation';
import CLoading from '@/components/CLoading.vue';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';

// import axios from '@/plugins/http';

// import { colSize } from 'ant-design-vue/lib/grid/Col';
interface orderUser {
  created_at: string;
  id?: number;
  mobile: string;
  name?: string;
}
interface FileItem {
  uid: string;
  name: string;
  status?: string;
  response?: string;
  url?: string;
  preview?: string;
  originFileObj?: any;
  file: string | Blob;
}
// 批量导入
interface SRData {
  created_at: string;
  fail_num: number;
  success_num: number;
  total_num: number;
  type: number;
}

const __default__ = { name: 'EventReservation' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const liveBroadcastingRoomId = router.currentRoute.value.params.studioId;
const liveInfo = computed(() => unref(inject('liveInfo')) as LiveInfo);
const aRadioGroup = Radio.Group;
const aInputSearch = Input.Search;
const aDropdown = Dropdown;
const aMenu = Menu;
const aMenuItem = Menu.Item;
const aTable = Table;
const aModal = Modal;
const aPagination = Pagination;
const aUpload = Upload;
const aDatePicker = DatePicker;
// 获取页面数据
const showLoading = ref<boolean>(true);
const checked = ref<boolean>(false);
const valueStart = ref<Moment | string | null>(null);
const valueSend = ref<Moment | null>(null);
const valueTip = ref(0);
const sendType = ref(1);
const valueSearch = ref('');
const public_name = ref('轻视云');
const getdata = () => {
  const data = {
    studio_id: liveBroadcastingRoomId,
  };
  http.reserve_msg_view({ params: data }).then((res) => {
    checked.value = res.data.data.status ? true : false;
    setTimeout(() => {
      valueStart.value = res.data.data.start_at ? moment(res.data.data.start_at) : '';
    }, 300);
    if (res.data.data.send_time) {
      valueSend.value = moment(res.data.data.send_time);
    }
    valueTip.value = res.data.data.eject_reserve ? res.data.data.eject_reserve : 0;
    public_name.value = res.data.data.public_name == '' ? '轻视云' : res.data.data.public_name;
    sendType.value = res.data.data.type;
    gettable();
  });
};
getdata();
//  获取表格数据
const orderUserData = ref<orderUser[]>([]);
const pageConfigure = reactive({
  current: 1, // 当前页
  pageSize: 5, // 每页条数
  totalSize: 10, // 总数
  options: ['5', '10', '20', '30', '50'], // 选项
});
const gettable = useDebounce(() => {
  if (sendType.value == 1) {
    //短信
    const data = {
      studio_id: liveBroadcastingRoomId,
      page: pageConfigure.current,
      page_num: pageConfigure.pageSize,
    };
    showLoading.value = true;
    orderUserData.value = [];
    http
      .reserve_msg_user({ params: data })
      .then((res) => {
        pageConfigure.totalSize = res.data.data.total;
        showLoading.value = false;
        orderUserData.value = res.data.data.data;
      })
      .catch((res) => {
        showLoading.value = false;
      });
  } else {
    const data = {
      studio_id: liveBroadcastingRoomId,
      username: valueSearch.value,
      page: pageConfigure.current,
      page_num: pageConfigure.pageSize,
    };
    showLoading.value = true;
    orderUserData.value = [];
    http
      .we_chat_reserve_user({ params: data })
      .then((res) => {
        pageConfigure.totalSize = res.data.data.total;
        showLoading.value = false;
        orderUserData.value = res.data.data.data;
      })
      .catch((res) => {
        showLoading.value = false;
      });
  }
});

const columns = [
  {
    title: '用户名',
    dataIndex: 'name',
    align: 'center',
    key: 'name',
    width: '20%',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
    align: 'center',
    key: 'mobile',
    width: '20%',
  },
  {
    title: '报名时间',
    dataIndex: 'created_at',
    align: 'center',
    key: 'created_at',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    align: 'center',
    key: 'operation',
    width: '130px',
    slots: { customRender: 'operation' },
  },
];
const columns1 = [
  {
    title: '用户名',
    dataIndex: 'username',
    align: 'center',
    key: 'username',
  },
  {
    title: '报名时间',
    dataIndex: 'created_at',
    align: 'center',
    key: 'created_at',
  },
];
const selectedRowKeys = ref<Key[]>([]); // Check here to configure the default column
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
  // console.log('selectedRowKeys changed: ', selectedRowKeys.value.join(','));
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});
const orderUserId = ref();
const openDelModal = (e: number) => {
  orderUserId.value = e;
  delModal.visible = !delModal.visible;
};
//如果没有选中，不能删除
const getSelected = computed(() => selectedRowKeys.value.length === 0);
const dsnClean = computed(() => orderUserData.value.length === 0);
// 删除事件
const delUserData = () => {
  const data = {
    id: selectedRowKeys.value.join(',') ? selectedRowKeys.value.join(',') : orderUserId.value,
    studio_id: liveBroadcastingRoomId,
    type: sendType.value,
  };
  http
    .reserve_msg_user_delete(data)
    .then((res) => {
      delModal.visible = false;
      selectedRowKeys.value.length = 0;
      message.success(res.data.message);
      gettable();
    })
    .catch(() => {
      // message.error(res.data.message);
    });
};
// 清空记录
const openClean = ref(false);
const openCleanModal = () => {
  openClean.value = false;
};
const cleanUserData = () => {
  openClean.value = false;
  const data = {
    studio_id: liveBroadcastingRoomId,
    type: sendType.value,
  };
  http.reserve_msg_user_clean(data).then((res) => {
    message.destroy();
    message.success(res.data.message);
    gettable();
  });
};
// 搜索
const userSearch = () => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    keywords: valueSearch.value,
    page: 1,
    page_num: 5,
  };
  http.reserve_msg_user_search({ params: data }).then((res) => {
    pageConfigure.totalSize = res.data.data.total;
    orderUserData.value = res.data.data.data;
  });
};
//下载excel模板
const dowload_excl = () => {
  window.location.href = 'https://static.lighos.com/default/reservation.xlsx';
};
const addNumber = ref<boolean>(false);
const valueAddNumber = ref('');
const valueAddName = ref('');
// 添加手机号
const createNum = () => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    mobile: valueAddNumber.value,
    name: valueAddName.value,
  };
  http
    .reserve_msg_user_create(data)
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
      addNumber.value = false;
      gettable();
      valueAddNumber.value = '';
      valueAddName.value = '';
    })
    .catch((res) => {
      message.error(res.data.error);
      // message.error(res.data.message);
    });
};
const setNumber = ref(false);
const valuesetNumber = ref('');
const valuesetName = ref('');
const setnumdata = {
  id: 0,
};
const opensetNumber = (num: string, id: number, name: string) => {
  valuesetNumber.value = num;
  setnumdata.id = id;
  valuesetName.value = name;
  setNumber.value = !setNumber.value;
};
// 修改手机号
const updataNum = () => {
  const data = {
    id: setnumdata.id,
    mobile: valuesetNumber.value,
    name: valuesetName.value,
    studio_id: liveBroadcastingRoomId,
  };
  http
    .reserve_msg_user_update(data)
    .then((res) => {
      setNumber.value = false;
      message.success(res.data.message);
      gettable();
    })
    .catch((res) => {
      // message.error(res.data.message);
    });
};
// 导出数据
const { proxy }: any = getCurrentInstance();
const token = getToken();
const corn = ref(1);
const messageTip = ref();

const ExportTemplate = useDebounce(() => {
  // let url;
  if (sendType.value == 1) {
    const data = {
      studio_id: liveBroadcastingRoomId,
      type: 27,
      is_cron_download: corn.value,
    };
    https
      .excel_regional_distribution({ params: data })
      .then((res: any) => {
        messageTip.value = res.data.message;
        openNotificationWithIcon('success');
      })
      .catch((res: any) => {
        messageTip.value = res.data.error;
        openNotificationWithIcon('error');
      });
  } else {
    const data = {
      studio_id: liveBroadcastingRoomId,
      export: 1,
      is_cron_download: corn.value,
    };
    https
      .we_chat_reserve_user({ params: data })
      .then((res: any) => {
        messageTip.value = res.data.message;
        openNotificationWithIcon('success');
      })
      .catch((res: any) => {
        messageTip.value = res.data.error;
        openNotificationWithIcon('error');
      });
  }
});
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};
const fileList = ref<FileItem[]>([]);
const openImport = ref(false);
const valueImport = ref(0);
// const fileData = ref();
const beforeUpload = (file: FileItem) => {
  if (fileList.value.length === 1) {
    handleRemove(fileList.value[0]);
  }
  fileList.value = [...fileList.value, file];
  return false;
};
const handleRemove = (file: FileItem) => {
  const index = fileList.value.indexOf(file);
  const newFileList = fileList.value.slice();
  newFileList.splice(index, 1);
  fileList.value = newFileList;
};

const reserveImport = () => {
  const formData = new FormData();
  // const data = {
  //   type: valueImport.value,
  //   studio_id: liveBroadcastingRoomId,
  //   file: formData.get('files'),
  // };
  formData.append('type', valueImport.value.toString());
  formData.append('studio_id', liveBroadcastingRoomId.toString());
  if (valueImport.value === 0) {
    formData.append('file', fileList.value[0] as any);
  }

  http
    .reserve_msg_import(formData)
    .then((res) => {
      openImport.value = false;
      message.destroy();
      message.success(res.data.message);
      gettable();
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
      // message.error(res.data.message);
    });
};

// 发送记录
const openRecord = ref(false);
const sendRecordData = ref<SRData[]>([]);
const sendColumns = [
  {
    title: '发送类型',
    dataIndex: 'type',
    align: 'center',
    key: 'type',
    width: '20%',
    slots: { customRender: 'sendType' },
  },
  {
    title: '发送数量',
    dataIndex: 'total_num',
    align: 'center',
    key: 'total_num',
    width: '20%',
  },
  {
    title: '状态',
    dataIndex: 'stutas',
    align: 'center',
    key: 'stutas',
    width: '20%',
    slots: { customRender: 'stutas' },
  },
  {
    title: '发送时间',
    dataIndex: 'created_at',
    align: 'center',
    key: 'created_at',
    width: '20%',
  },
];
const pageConfigRecord = reactive({
  page: 1, // 当前页
  page_num: 5, // 每页条数
  totals: 10, // 总数
  options: ['5', '10', '20', '30', '50'], // 选项
});
const getRecord = () => {
  openRecord.value = true;
  const data = {
    studio_id: liveBroadcastingRoomId,
    type: sendType.value,
    page: pageConfigRecord.page,
    page_num: pageConfigRecord.page_num,
  };
  showLoading.value = true;
  http
    .reserve_msg_record({ params: data })
    .then((res) => {
      showLoading.value = false;
      if (res.data.data.data.length > 0) {
        sendRecordData.value = res.data.data.data;
        pageConfigRecord.totals = res.data.data.total;
      } else {
        sendRecordData.value = [];
        pageConfigRecord.totals = 1;
      }
    })
    .catch(() => {
      showLoading.value = false;
      // message.error(res.data.message);
    });
};

// 手动发送
const reserveSend = useDebounce(() => {
  const data = {
    studio_id: liveBroadcastingRoomId,
  };
  if (sendType.value == 1) {
    http
      .reserve_msg_send(data)
      .then((res) => {
        message.destroy();
        message.success(res.data.message);
      })
      .catch((res) => {
        message.error(res.data.error);
      });
  } else {
    http
      .we_chat_send_message(data)
      .then((res) => {
        message.destroy();
        message.success(res.data.message);
      })
      .catch((res) => {
        message.error(res.data.error);
      });
  }
});

// 直播间创建时间
const creaded_time = ref();
const getLiveInfoAt = () => {
  const data = {
    studio_id: liveBroadcastingRoomId,
  };
  http.getLiveInfo({ params: data }).then((res) => {
    creaded_time.value = res.data.data.start_at;
  });
};
getLiveInfoAt();
// 保存
const saveReserve = useDebounce(() => {
  const data = {
    eject_reserve: valueTip.value,
    public_name: public_name.value,
    send_time: valueSend.value ? dateFormat(valueSend.value) : '',
    start_at: valueStart.value ? dateFormat(valueStart.value) : '',
    status: checked.value ? 1 : 0,
    studio_id: liveBroadcastingRoomId,
    type: sendType.value,
  };
  http
    .reserve_msg_save(data)
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
    })
    .catch((res) => {
      message.error(res.data.error);
    });
});
//时间格式化函数，此处仅针对yyyy-MM-dd hh:mm:ss 的格式进行格式化
const dateFormat = (time: any) => {
  var date = new Date(time);
  var year = date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  // 拼接 format="YYYY-MM-DD hh:mm:ss"
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
};
const disabledDate = (current: any) => {
  return current && current < moment().subtract(1, 'days'); //当天之前的不可选，不包括当天
  //return current && current < moment().endOf(‘day’);当天之前的不可选，包括当天
};

// 微信批量导入
const weChatImport = () => {
  const data = {
    studio_id: liveBroadcastingRoomId,
  };
  http
    .weChatImport(data)
    .then((res) => {
      gettable();
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_a_switch, {
          checked: checked.value,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
          onChange: _unref(saveReserve)
        }, null, 8, ["checked", "onChange"])
      ]),
      (showLoading.value)
        ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("img", {
                  src: _unref(liveInfo).image_player_cover_url,
                  style: {"width":"100%","height":"100%"}
                }, null, 8, _hoisted_7), [
                  [_vShow, _unref(liveInfo).image_player_cover_url]
                ])
              ]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_unref(aRadioGroup), {
                  value: sendType.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((sendType).value = $event)),
                  onChange: _unref(gettable)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("短信")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("微信")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_a_input, {
                  value: public_name.value,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((public_name).value = $event)),
                  placeholder: "请输入公众号名称",
                  disabled: "",
                  style: {"width":"220px"}
                }, null, 8, ["value"])
              ], 512), [
                [_vShow, sendType.value == 2]
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_unref(aDatePicker), {
                  "show-time": "",
                  placeholder: "请选择日期时间",
                  value: valueStart.value,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((valueStart).value = $event)),
                  disabledDate: disabledDate
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_unref(aDatePicker), {
                  "show-time": "",
                  placeholder: "请选择日期时间",
                  value: valueSend.value,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((valueSend).value = $event)),
                  disabledDate: disabledDate
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  size: "small",
                  style: {"font-size":"13px","border-radius":"4px","height":"32px"},
                  onClick: _unref(reserveSend)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("手动发送")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_unref(aRadioGroup), {
                  value: valueTip.value,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((valueTip).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("开")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("关")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_20, [
                (valueStart.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "短信内容：您预约的活动“" + _toDisplayString(_unref(liveInfo).title) + "“，将要在" + _toDisplayString(dateFormat(valueStart.value)) + "开始啦，请您尽快前往活动地址。", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, "短信内容：您预约的“" + _toDisplayString(_unref(liveInfo).title) + "“，将要在 " + _toDisplayString(creaded_time.value) + "开始啦，请您尽快前往活动地址。", 1))
              ], 512), [
                [_vShow, sendType.value == 1]
              ]),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createVNode(_component_a_button, {
                  type: "primary",
                  class: "itemBut_button",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (addNumber.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加手机号")
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, sendType.value == 1]
                ]),
                _createVNode(_unref(aInputSearch), {
                  class: "itemBut_input",
                  value: valueSearch.value,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((valueSearch).value = $event)),
                  placeholder: sendType.value == 1 ? '请输入手机号' : '请输入用户名',
                  onChange: userSearch
                }, {
                  enterButton: _withCtx(() => [
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SearchOutlined), {
                          class: "worp_head_search_svg",
                          onClick: userSearch
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "placeholder"]),
                _createVNode(_component_a_button, {
                  type: "link",
                  class: "excel",
                  onClick: dowload_excl
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载Excel模板")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  onClick: openDelModal,
                  style: {"right":"90px","position":"absolute"},
                  disabled: _unref(getSelected)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(aDropdown), null, {
                  overlay: _withCtx(() => [
                    _createVNode(_unref(aMenu), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(aMenuItem), null, {
                          default: _withCtx(() => [
                            (sendType.value == 1)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "text",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (openImport.value = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("批量导入")
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_a_button, {
                                  key: 1,
                                  type: "text",
                                  onClick: weChatImport
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("批量导入")
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(aMenuItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "text",
                              onClick: _unref(ExportTemplate),
                              disabled: _unref(dsnClean)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("导出数据")
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(aMenuItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "text",
                              onClick: getRecord
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("发送记录")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(aMenuItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "text",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (openClean.value = true)),
                              disabled: _unref(dsnClean)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("清空记录")
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { style: {"right":"0","position":"absolute"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 更多 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_unref(aTable), {
                  loading: showLoading.value,
                  columns: sendType.value == 1 ? columns : columns1,
                  rowKey: "id",
                  "data-source": orderUserData.value,
                  "row-selection": _unref(rowSelection),
                  pagination: false
                }, {
                  operation: _withCtx(({ record }) => [
                    _createVNode(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (opensetNumber(record.mobile, record.id, record.name))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-class": "reser_updata" })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (openDelModal(record.id))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-class": "whiteList_del" })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "data-source", "row-selection"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_unref(aPagination), {
                  "show-quick-jumper": "",
                  current: pageConfigure.current,
                  "onUpdate:current": _cache[10] || (_cache[10] = ($event: any) => ((pageConfigure.current) = $event)),
                  pageSize: pageConfigure.pageSize,
                  "onUpdate:pageSize": _cache[11] || (_cache[11] = ($event: any) => ((pageConfigure.pageSize) = $event)),
                  onShowSizeChange: _unref(gettable),
                  onChange: _unref(gettable),
                  pageSizeOptions: pageConfigure.options,
                  total: pageConfigure.totalSize,
                  "show-less-items": "",
                  "show-size-changer": ""
                }, null, 8, ["current", "pageSize", "onShowSizeChange", "onChange", "pageSizeOptions", "total"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _unref(saveReserve)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ])),
      _createVNode(CDelModal, {
        visible: delModal.visible,
        centered: "",
        close: openDelModal,
        ok: delUserData
      }, null, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: addNumber.value,
        "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((addNumber).value = $event)),
        centered: "",
        title: "添加手机号"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            class: "mod_modal_btn",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (addNumber.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: createNum
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_a_input, {
                class: "input",
                size: "default",
                value: valueAddName.value,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((valueAddName).value = $event)),
                placeholder: "请输入名称"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode(_component_a_input, {
                class: "input",
                value: valueAddNumber.value,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((valueAddNumber).value = $event)),
                placeholder: "请输入手机号",
                onkeyup: "value=value.replace(/\\D/g,'')"
              }, null, 8, ["value"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: setNumber.value,
        "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((setNumber).value = $event)),
        centered: "",
        title: "修改手机号"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            class: "mod_modal_btn",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (setNumber.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: updataNum
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode(_component_a_input, {
                class: "input",
                value: valuesetName.value,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((valuesetName).value = $event)),
                placeholder: "请输入手机号"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createVNode(_component_a_input, {
                class: "input",
                value: valuesetNumber.value,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((valuesetNumber).value = $event)),
                placeholder: "请输入手机号"
              }, null, 8, ["value"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: openImport.value,
        "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((openImport).value = $event)),
        centered: "",
        title: "批量导入"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            class: "mod_modal_btn",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (openImport.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: reserveImport
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(aRadioGroup), {
            name: "radioGroup",
            value: valueImport.value,
            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((valueImport).value = $event)),
            class: "import_cen mar_bot"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, { value: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("文件")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("注册表单")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: 2 }, {
                default: _withCtx(() => [
                  _createTextVNode("手机白名单")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: 3 }, {
                default: _withCtx(() => [
                  _createTextVNode("身份赋予")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          (valueImport.value === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _hoisted_38,
                _hoisted_39,
                _createVNode(_unref(aUpload), {
                  "file-list": fileList.value,
                  showUploadList: false,
                  name: "file",
                  "before-upload": beforeUpload,
                  accept: ".xlsx,.xls,.csv",
                  remove: handleRemove
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "mar_top"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("选取文件")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"]),
                _hoisted_40,
                _createTextVNode(" " + _toDisplayString(fileList.value.length > 0 ? fileList.value[0].name : '') + " ", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: openRecord.value,
        "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((openRecord).value = $event)),
        centered: "",
        title: "发送记录",
        width: "800px",
        footer: null
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_unref(aTable), {
              loading: showLoading.value,
              columns: sendColumns,
              rowKey: "id",
              "data-source": sendRecordData.value,
              pagination: false
            }, {
              sendType: _withCtx(({ record }) => [
                (record.type === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, "短信"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_43, "微信"))
              ]),
              stutas: _withCtx(({ record }) => [
                (record.fail_num === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, "全部成功"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_45, "成功" + _toDisplayString(record.success_num) + " / 失败" + _toDisplayString(record.fail_num), 1))
              ]),
              _: 1
            }, 8, ["loading", "data-source"])
          ]),
          _createVNode(_unref(aPagination), {
            "show-quick-jumper": "",
            current: pageConfigRecord.page,
            "onUpdate:current": _cache[23] || (_cache[23] = ($event: any) => ((pageConfigRecord.page) = $event)),
            pageSize: pageConfigRecord.page_num,
            "onUpdate:pageSize": _cache[24] || (_cache[24] = ($event: any) => ((pageConfigRecord.page_num) = $event)),
            onShowSizeChange: getRecord,
            onChange: getRecord,
            pageSizeOptions: pageConfigRecord.options,
            total: pageConfigRecord.totals,
            class: "openRecord_page"
          }, null, 8, ["current", "pageSize", "pageSizeOptions", "total"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(CDelModal, {
        visible: openClean.value,
        centered: "",
        close: openCleanModal,
        ok: cleanUserData
      }, {
        title: _withCtx(() => [
          _createTextVNode("此操作将清空该文件，是否继续？")
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}
}

})